import styled, { css } from 'styled-components'

import { colors } from '@theme/variables'

export const PopupRoot = styled('div')`
  position: absolute;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 11;
`

export const PopupDimmer = styled('div')`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: 0.5;
  background: ${colors.black};
  overflow: hidden;
`

export const PopupInner = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  background: ${colors.white};
  position: relative;
  z-index: 11;
  width: calc(100% - 16px);
  max-width: 360px;
  height: 616px;
  padding: 0 16px;
  flex-direction: column;
`

export const PopupCloseButtonBox = styled('div')`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
  cursor: pointer;
`

export const ArrowBox = styled('div')<{ $disabled: boolean }>`
  width: 36px;
  height: 88px;
  cursor: pointer;
  transform: rotate(90deg);

  ${({ $disabled }: { $disabled: boolean }) =>
    $disabled
      ? css`
          cursor: initial;
          pointer-events: none;
        `
      : ''}
`

export const PopupContent = styled('div')`
  display: flex;
  align-items: center;
  gap: 24px;
  overflow-y: auto;
  overflow-x: scroll;
  scroll-behavior: smooth;
  flex: 1;
  flex-direction: column;
`
